var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M53 26.456c2.667 1.575 2.667 5.513 0 7.088L21 52.446c-2.667 1.575-6-.394-6-3.544V11.098c0-3.15 3.333-5.119 6-3.544l32 18.902z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+CiAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTUyLjk5OTk3NzcsMjYuNDU1OTQ2NCBDNTUuNjY2Njc0MSwyOC4wMzEwNDYzIDU1LjY2NjY3NDEsMzEuOTY4OTQ2MSA1Mi45OTk5Nzc3LDMzLjU0NDA0NiBMMjAuOTk5OTg0NSw1Mi40NDU2NDUxIEMxOC4zMzMzMjYxLDU0LjAyMDc0NSAxNSw1Mi4wNTE4NDUxIDE1LDQ4LjkwMTU0NTMgTDE1LDExLjA5ODQxNzEgQzE1LDcuOTQ4MTUwMjkgMTguMzMzMzM2MSw1Ljk3OTIzNzM5IDIxLDcuNTU0Mzc0MzEgTDUyLjk5OTk3NzcsMjYuNDU1OTQ2NCBaIi8+Cjwvc3ZnPgo=";
export { SvgPlay as ReactComponent };